var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1942 0 0 11.1942 0 25C0 38.8058 11.1942 50 25 50C38.8058 50 50 38.8058 50 25C50 11.1942 38.8058 0 25 0ZM39.2857 14.1574L37.0089 16.3393C36.808 16.49 36.7132 16.7355 36.7522 16.9754V33.0301C36.7132 33.2757 36.808 33.5212 37.0089 33.6663L39.2411 35.8482V36.3337H28.0357V35.8705L30.3404 33.6328C30.5692 33.404 30.5692 33.3371 30.5692 32.9967V20.0056L24.1518 36.2779H23.2868L15.8203 20.0056V30.9152C15.7533 31.3728 15.9152 31.8359 16.2388 32.1652L19.2411 35.798V36.2835H10.7143V35.798L13.7165 32.1652C13.8747 32.0018 13.9924 31.8036 14.0602 31.5866C14.1281 31.3695 14.1441 31.1396 14.1071 30.9152V18.3036C14.1462 17.952 14.0123 17.6116 13.7444 17.3717L11.077 14.1574V13.6719H19.3638L25.7589 27.7065L31.3895 13.683H39.2857V14.1574Z",
    fill: "url(#paint0_linear_944_319)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_319",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA14F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinIcon3);
export default __webpack_public_path__ + "static/media/join_icon_3.3e255d3697583a03205e66d6c1d11282.svg";
export { ForwardRef as ReactComponent };